/**
 * 파워북
 */
import { Fragment } from 'react';
import { useLoaderData } from 'react-router-dom';
import Header from '@features/content/Header';
import { apiSearchSlice } from '@features/api/apiSearchSlice';
import { setRequestToSearchParams } from '@utils/index';
import { ALIAS, CUR_NETWORK, NETWORK } from '@constants/index';
import { getLocalData } from '@features/api/apiLocalSlice';
import NoData from '../../components/contents/common/NoData';
import { useAppSelector } from '@hooks/defineRtkTypedHook';
import { selectL10N, setAlias } from '@features/ui/UiSlice';
import PowerbookArticle from '@components/contents/article/PowerbookArticle';
import Paging from '@components/contents/common/Paging';
import type { IContentData, ILoaderData, IPowerbook } from '@type/index';

export const PowerbookLoader =
  (dispatch, option: IOption) =>
  async ({ request }): Promise<IPowerbook | null> => {
    const searchParams = setRequestToSearchParams(request);

    // alias 변경 - searchParams 변경에 사용됨
    dispatch(setAlias(ALIAS.POWERBOOK));

    if (!searchParams?.keyword) {
      return null;
    }

    return CUR_NETWORK === NETWORK.OPDEV
      ? await getLocalData(ALIAS.POWERBOOK, searchParams)
      : await dispatch(apiSearchSlice?.endpoints?.getPowerbook?.initiate({ option, params: searchParams }));
  };

interface IContentComponentProps {
  data: IContentData<IPowerbook>;
}
const ContentComponent = ({ data }: IContentComponentProps) => {
  const l10n = useAppSelector(selectL10N);

  return (
    <Fragment>
      <div className="search-content">
        <ul className="column column-2">
          {data?.list.map((item, i) => (
            <li key={i} className="search-item">
              <PowerbookArticle item={item} />
            </li>
          ))}
        </ul>
      </div>
      <Paging endPage={data?.pagination?.endPage} showPage={5} l10n={l10n!} />
    </Fragment>
  );
};

const Powerbook = () => {
  const { data, isLoading, isError } = (useLoaderData() as ILoaderData<IContentData<IPowerbook>>) || {};

  if (isError || !Array.isArray(data?.list) || data?.list?.length === 0) {
    return <NoData />;
  }

  return (
    <div className="search-result powerbook">
      <Header totalCount={data?.pagination?.total} />
      <ContentComponent data={data} />
    </div>
  );
};

export default Powerbook;
